import logoImage from '@/assets/podbrief-logo.png';

export function Logo({ size = 'default' }: { size?: 'default' | 'large' }) {
  return (
    <img
      src={logoImage}
      alt="PodBrief Logo"
      className="h-auto"
      style={{ width: '150px' }}
    />
  );
}
